<template>
  <v-card>
    <div class="empty-container">
      <div class="empty-container__header">
        <div class="empty-container__text">
          {{ $t("message.storeLocator.placeholder.title") }}
        </div>
        <div class="empty-container__image"></div>
      </div>
      <div class="empty-container__subheader">
        {{ $t("message.storeLocator.placeholder.subtitle") }}
      </div>
      <ul class="feature-list">
        <li class="feature-list__el">
          <div class="feature-list__header">
            <div class="feature-list__icon icon-visibility"></div>
            <div class="feature-list__title">
              {{
                $t("message.storeLocator.placeholder.list.firstElement.title")
              }}
            </div>
          </div>
          <div class="feature-list__text">
            {{
              $t(
                "message.storeLocator.placeholder.list.firstElement.description"
              )
            }}
          </div>
        </li>
        <li class="feature-list__el">
          <div class="feature-list__header">
            <div class="feature-list__icon icon-traffic"></div>
            <div class="feature-list__title">
              {{
                $t("message.storeLocator.placeholder.list.secondElement.title")
              }}
            </div>
          </div>
          <div class="feature-list__text">
            {{
              $t(
                "message.storeLocator.placeholder.list.secondElement.description"
              )
            }}
          </div>
        </li>
        <li class="feature-list__el">
          <div class="feature-list__header">
            <div class="feature-list__icon icon-time"></div>
            <div class="feature-list__title">
              {{
                $t("message.storeLocator.placeholder.list.thirdElement.title")
              }}
            </div>
          </div>
          <div class="feature-list__text">
            {{
              $t(
                "message.storeLocator.placeholder.list.thirdElement.description"
              )
            }}
          </div>
        </li>
        <li class="feature-list__el">
          <div class="feature-list__header">
            <div class="feature-list__icon icon-integration"></div>
            <div class="feature-list__title">
              {{
                $t("message.storeLocator.placeholder.list.fourthElement.title")
              }}
            </div>
          </div>
          <div class="feature-list__text">
            {{
              $t(
                "message.storeLocator.placeholder.list.fourthElement.description"
              )
            }}
          </div>
        </li>
      </ul>
      <div class="contact">
        <div class="contact__subtitle">
          {{ $t("message.storeLocator.placeholder.implementedIn") }}
          <a :href="neonetSLUrl" target="_blank">{{ neonetSLUrl }}</a>
        </div>
        <div class="contact__title">
          {{ $t("message.storeLocator.placeholder.contactText") }}
        </div>
        <div class="contact__tile">
          <div class="contact__avatar"></div>
          <div class="contact__list">
            <div class="contact__name">
              {{ $t("message.storeLocator.placeholder.consultantName") }}
            </div>
            <div class="contact__data">
              {{ $t("message.storeLocator.placeholder.phone") }}
            </div>
            <div class="contact__data">
              <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import constants from "@/config/constants";

export default {
  name: "StoreLocatorConfigEmpty",
  data: () => ({
    supportEmail: constants.supportEmail,
    neonetSLUrl: constants.neonetSLUrl
  })
};
</script>

<style lang="scss" scoped src="./ConfigEmpty.scss"></style>
